import React, { useState, useCallback, useMemo } from "react";
import './Shop.css';
import { usePlayerStore } from "../../store/store";
import DraggableModal from '../Modal/DraggableModal';

function Shop({ displayModal, shopList, shopInfo, sendMessage }) {
    const [sellMode, setSellMode] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [amount, setAmount] = useState(1);
    const [selectedFilter, setSelectedFilter] = useState('all');

    const gold = usePlayerStore((state) => state.gold);

    const filterList = (filter) => {
        setSelectedFilter(filter);
    };

    const filteredShopList = useMemo(() => {
        return shopList?.list?.filter((e) => {
            if (selectedFilter === 'all') return true;
            return e.type2 === selectedFilter;
        });
    }, [selectedFilter, shopList]);


    function getItemInfo(item, itemId, index, cost, amount) {
        if (sellMode) {
            sendMessage('316' + shopList.shopId + ';shop sinfo ' + index + ";" + itemId);
        } else {
            sendMessage('316' + shopList.shopId + ';shop info ' + item + ";" + itemId);
        }
        setSelectedItem({ item, itemId, index, cost, amount });
        setAmount(1);
    }

    function buyItem() {
        if (selectedItem) {
            if (sellMode) {
                sendMessage('316' + shopList.shopId + ";shop sell " + amount + "," + selectedItem.index + "," + selectedItem.itemId);
            } else {
                sendMessage('316' + shopList.shopId + ";shop buy " + amount + "," + selectedItem.item + "," + selectedItem.itemId);
            }
        }
    }

    function getSellItems() {
        if (!sellMode) {
            setSellMode(true);
            setSelectedItem(null);
            sendMessage('316' + shopList.shopId + ';shop blist');
        }
    }

    function getBuyItems() {
        if (sellMode) {
            setSellMode(false);
            setSelectedItem(null);
            sendMessage('316' + shopList.shopId + ';shop');
        }
    }

    const changeAmount = (e, value) => {
        e.preventDefault();
        e.stopPropagation();
        setAmount(Number(value));
    };

    const incrementAmount = (amount) => {
        setAmount(prev => (prev + amount));
    }

    const setMax = () => {
        if (!selectedItem) {
            return;
        }

        if (sellMode) {
            console.log("amount: " + selectedItem.item.amount)
            setAmount(selectedItem.amount);
        } else {
            const amt = Math.round(Math.floor(gold / selectedItem.cost));
            setAmount(amt);
        }
    }


    return (
        <DraggableModal modalId="shop" onClose={displayModal}>
            <div className="modal-content" style={{ width: '900px' }}>
                <div className="tmodal-header">
                    <span className="close" onClick={displayModal}>&times;</span>
                    <h2>Shop</h2>
                </div>
                <div className="modal-body" style={{ width: '100%', padding: '2px 5px' }}>
                    <div className="shop" style={{ height: '100%' }} >
                        <div>
                            <ShopOptions getSellItems={getSellItems} getBuyItems={getBuyItems} sellMode={sellMode} />
                            <ul className="shop-list">
                                {filteredShopList?.map((e, i) => <ShopItem key={e.itemId} item={e} itemInfo={getItemInfo} index={i} selected={selectedItem?.itemId} />)}
                            </ul>
                            <select className="shop-filter" onChange={(e) => filterList(e.currentTarget.value)}>
                                <option value="all">All</option>
                                <optgroup label="Armours">
                                    <option value="HEAD">Head</option>
                                    <option value="NECK">Neck</option>
                                    <option value="BODY">Body</option>
                                    <option value="HANDS">Hands</option>
                                    <option value="FEET">Feet</option>
                                    <option value="WRIST">Wrist</option>
                                    <option value="FINGER">Finger</option>
                                    <option value="OFFHAND">Offhand</option>
                                    <option value="Shield">Shield</option>
                                </optgroup>
                                <optgroup label="Weapons">
                                    <option value="SWORD">Sword</option>
                                    <option value="DAGGER">Dagger</option>
                                    <option value="STAFF">Staff</option>
                                    <option value="MACE">Mace</option>
                                    <option value="HAMMER">Hammer</option>
                                </optgroup>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="shop-info">
                            <p className="ability-points">Available Gold (<span className="available-gold-amount">{gold.toLocaleString()}</span>)</p>

                            <div className="info-header">
                                <p>Information</p>
                            </div>
                            {shopInfo &&
                                <>
                                    <div className="info-desc">
                                        <Information shopInfo={shopInfo} />
                                        <p className="description">{shopInfo.description}</p>
                                        <div className="stats">
                                            <Requirements reqs={shopInfo.requirements} />
                                            <Modifiers mods={shopInfo.modifiers} uniMods={shopInfo.uniModifiers} />
                                        </div>
                                    </div>
                                    {shopInfo.maxSockets > 0 && <SocketItem shopInfo={shopInfo} />}
                                </>
                            }
                            <div className="bottom">
                                <button className="ts-button" onClick={e => buyItem(1)}>{sellMode ? 'Sell' : 'Buy'}</button>
                                <div>
                                    <BuyAmount amount={amount} changeAmount={changeAmount} selectedItem={selectedItem} gold={gold} sellMode={sellMode}/>
                                    <div className="shop-increment">
                                        <button className="incrementor-button" onClick={e => incrementAmount(1)}>+1</button>
                                        <button className="incrementor-button" onClick={e => incrementAmount(5)}>+5</button>
                                        <button className="incrementor-button" onClick={e => incrementAmount(10)}>+10</button>
                                        <button className="incrementor-button" onClick={e => setMax()}>{sellMode ? 'All' : 'Max'}</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="ts-close" onClick={displayModal}>Close</button>
                </div>
            </div>
        </DraggableModal>
    );
}

const BuyAmount = ({ selectedItem, amount, changeAmount, gold,sellMode }) => {
    let col = ' green';
    if (selectedItem && !sellMode) {
        col = (amount * selectedItem.cost) <= gold ? ' green' : ' red' || '';
    }

    return (
        <div className="buy-amount">
            <div className="buy-wrap">
                <span className="total">Total: </span><p className={"total-cost" + col} >{selectedItem && (amount * selectedItem.cost).toLocaleString()}</p>
                <span className="total">x</span>
                <input type="number" className="amount" min={1} max={500}
                    value={amount}
                    onChange={(e) => changeAmount(e, e.currentTarget.value)}
                />
            </div>
        </div>
    );
}


export function Information({ shopInfo }) {
    return (
        <>
            {(shopInfo.type === 'Armour' || shopInfo.type === 'Shield') && <DisplayArmour shopInfo={shopInfo} />}
            {(shopInfo.type === 'Other' || shopInfo.type2 === 'Use') && <DisplayOther shopInfo={shopInfo} />}
            {shopInfo.type === 'Container' && <DisplayContainer shopInfo={shopInfo} />}
            {shopInfo.type?.startsWith('Weapon') && <DisplayWeapon shopInfo={shopInfo} />}
        </>
    );
}


function DisplayContainer({ shopInfo }) {
    return (
        <div className="info-info">
            <p className="name">Name <span className="value">{shopInfo.name}</span></p>
            <p className="name">Capacity <span className="value">{shopInfo.val}/{shopInfo.speed}</span></p>
        </div>
    );
}

function DisplayWeapon({ shopInfo }) {
    return (
        <div className="info-info">
            <p className="name">Name <span className="value">{shopInfo.name}</span></p>
            <p className="name">Type <span className="value">{shopInfo.type.slice(7)}</span></p>
            <p className="name">Slot <span className="value">{shopInfo.type2}</span></p>
            <p className="name">Damage <span className="value">{shopInfo.val}</span></p>
            <p className="name">Speed <span className="value">{((shopInfo.speed || 0) / 1000).toFixed(1)}s</span></p>
            <p className="name">Sockets <span className="value">{shopInfo.maxSockets}</span></p>
        </div>
    );
}

function DisplayArmour({ shopInfo }) {
    return (
        <div className="info-info">
            <p className="name">Name <span className="value">{shopInfo.name}</span></p>
            <p className="name">Type <span className="value">{shopInfo.type}</span></p>
            <p className="name">Slot <span className="value">{shopInfo.type2}</span></p>
            <p className="name">Armour <span className="value">{shopInfo.val}</span></p>
            <p className="name">Speed <span className="value">{((shopInfo.speed || 0) / 1000).toFixed(1)}s</span></p>
            <p className="name">Sockets <span className="value">{shopInfo.maxSockets}</span></p>
        </div>
    );
}

function DisplayOther({ shopInfo }) {
    return (
        <div className="info-info">
            <p className="name">Name <span className="value">{shopInfo.name}</span></p>
            <p className="name">Type <span className="value">{shopInfo.type}</span></p>
        </div>
    );
}

export function SocketItem({ shopInfo }) {
    return (
        <>
            <div className="sockets">
                <h3>Sockets</h3>
                {shopInfo.socketItems?.map((e, i) => <li key={i}><span className="socket-name">{e.name !== '' && <>{e.name}</>}</span><span className="socket-value">{e.value.slice(0, e.value.lastIndexOf(' '))}</span><span className="socket-value">{e.value.slice(e.value.lastIndexOf(' '))}</span></li>)}
            </div>
        </>
    )
}

export function Attribute({ name, value }) {
    return (
        <div className="attrib">
            <p className="attrib-name">{name}</p>
            <p className="attrib-value">{value}</p>
        </div>);
}

export function Requirements({ reqs }) {
    return (
        <>
            <div className="requirements">
                <h3>Requirements</h3>
                {reqs?.map((r, i) => <li key={i} className={r.meetsRequirement === true ? 'green' : 'red'}><Attribute name={r.name} value={r.val} /></li>)}
            </div>
        </>
    );
}
export function Modifiers({ mods, uniMods }) {
    return (
        <>
            <div className="modifiers">
                <h3>Modifiers</h3>
                {mods?.map((r, i) => <li key={i}><Attribute name={r.name} value={r.val} /></li>)}
                {uniMods?.map((r, i) => <li key={i} style={{ color: '#c46013' }}><Attribute name={r.name} value={r.val} /></li>)}
            </div>
        </>
    );
}
function ShopOptions({ getSellItems, getBuyItems, sellMode }) {
    return (
        <div className='shop-option'>
            <button className={"btn-option" + (!sellMode ? ' selected' : '')} onClick={getBuyItems}>Buy</button>
            <button className={"btn-option" + (sellMode ? ' selected' : '')} onClick={getSellItems}>Sell</button>
        </div>
    );
}


export function ShopItem({ item, itemInfo, index, selected }) {
    return (
        <li style={{ borderColor: selected === item.itemId ? 'white' : '' }}>
            <div className="item" onClick={(e) => itemInfo(item.name, item.itemId, index, item.cost, item.amount)}>
                <img src={require('../../Assets/gfx/' + item.picId + '.webp')} alt="" />
                <div className="item-info">
                    <span className="item-name" style={{ color: item.colour }}>
                        {item.name} {item.amount > 1 && <> ({item.amount})</>} {item.maxSockets > 0 && <> [{item.curSockets}/{item.maxSockets}]</>}
                        {item.maxCap > 0 && <> [{item.curCap}/{item.maxCap}]</>}
                    </span>
                    <span className="tag">

                    </span>
                    <div className="cost">
                        <p>Gold: <span className="gold">{item.cost.toLocaleString()}</span></p>
                    </div>
                </div>
            </div>
        </li>
    );
}


export default Shop;